export { default } from './Fact'
